import { Dispatch } from 'redux';

import { RootState } from '../reducers/store';
import { CustomersReducerActionType } from '../reducers/customersReducer';
import {
  ApiCustomersResponseType,
  InvitCustomersDataToPostType,
} from '../features/Customers/types';
import { CUSTOMERS_PER_PAGE } from '../features/Customers/CustomerList';

export const LIST_CUSTOMERS = 'list_customers';
export const ADD_CUSTOMER = 'add_CUSTOMER';
export const LIST_MEMBERS_CUSTOMERS = 'list_members_customer';
export const GET_CUSTOMER = 'get_customer';
export const DELETE_CUSTOMER = 'delete_customer';

export const listCustomers =
  (searchTerm: string, page = 1) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
    } = getState();

    get(
      `/back-office/profile/search?query=${searchTerm}&types[]=customer&per_page=${CUSTOMERS_PER_PAGE}&page=${page}`,
      (response: ApiCustomersResponseType): void => {
        response.data &&
          dispatch({
            type: LIST_CUSTOMERS,
            payload: {
              items: response.data,
              total: response.metadata?.total_count,
            },
          });
      }
    );
  };

export const addCustomer =
  (body: any, successCallback: () => void, failureCallback: () => void) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { post, get },
    } = getState();

    post(
      '/customers',
      body,
      (customerId: string) => {
        successCallback();
        get(`/customers/${customerId}`, (response: any) => {
          dispatch({
            type: ADD_CUSTOMER,
            payload: response.data,
          });
        });
      },
      failureCallback
    );
  };

export const getCustomer =
  (id: string) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
      customers: { items },
    } = getState();

    const customer = items.find((customer: any) => id === customer.id);

    if (customer) {
      dispatch({
        type: GET_CUSTOMER,
        payload: customer,
      });
    } else
      get(`/customers/${id}`, (response: any): void => {
        response.data &&
          dispatch({
            type: GET_CUSTOMER,
            payload: response.data,
          });
      });
  };

export const getCustomerMembers =
  (id: string) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { get },
    } = getState();

    get(`/customers/${id}/members`, (response: any): void => {
      response.data &&
        dispatch({
          type: LIST_MEMBERS_CUSTOMERS,
          payload: {
            items: response.data,
            total: response.metadata?.total_count,
          },
        });
    });
  };

export const editCustomer =
  (
    id: string,
    body: any,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { patch },
    } = getState();

    patch(
      `/customers/${id}`,
      body,
      () => {
        getCustomer(id)(dispatch, getState);
        successCallback();
      },
      () => failureCallback()
    );
  };

export const editCustomerMember =
  (
    id: string,
    body: any,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { put },
    } = getState();

    put(
      `/members`,
      body,
      () => {
        getCustomerMembers(id)(dispatch, getState);
        successCallback();
      },
      () => failureCallback()
    );
  };

export const deleteCustomerMember =
  (
    idUser: string,
    idCustomer: string,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { deletion },
    } = getState();
    deletion(
      `/members`,
      {
        source: {
          id: idUser,
          model_type: 'user',
        },
        target: {
          id: idCustomer,
          model_type: 'customer',
        },
      },
      () => {
        getCustomerMembers(idCustomer)(dispatch, getState);
        successCallback();
      },
      failureCallback
    );
  };

export const addUserToMembers =
  (
    body: {
      roles: Array<{ id: string }>;
      source: { id: string; model_type: string };
      target: { id: string; model_type: string };
    },
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { post },
    } = getState();

    post(
      '/members',
      body,
      () => {
        getCustomerMembers(body.target.id)(dispatch, getState);
        successCallback();
      },
      failureCallback
    );
  };

export const invitCustomers =
  (
    body: InvitCustomersDataToPostType,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { post },
    } = getState();

    post(
      '/invitations',
      {
        ...body,
        invitation_type: 'create_customer',
        text: 'Bonjour, Je vous invite à rejoindre Solidar-It !',
      },
      successCallback,
      failureCallback
    );
  };

export const deleteCustomer =
  (id: string, successCallback: () => void, failureCallback: () => void) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { deletion },
    } = getState();

    deletion(
      `/customers/${id}`,
      {},
      () => {
        dispatch({ type: DELETE_CUSTOMER, payload: id });
        successCallback();
      },
      failureCallback
    );
  };

export const updateCustomerSetting =
  (
    id: string,
    settingName: string,
    value: boolean,
    successCallback: () => void,
    failureCallback: () => void
  ) =>
  (
    dispatch: Dispatch<CustomersReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { put },
    } = getState();

    put(
      `/customers/${id}/settings/${settingName}`,
      { value: value.toString() },
      () => {
        getCustomer(id)(dispatch, getState);
        successCallback();
      },
      () => failureCallback()
    );
  };
